import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const LockOpenIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/lock-open"><g id="Icon"><path d="M5.99998 10.8002H18C19.3255 10.8002 20.4 11.8747 20.4 13.2002V20.4002C20.4 21.7257 19.3255 22.8002 18 22.8002H5.99998C4.67449 22.8002 3.59998 21.7257 3.59998 20.4002V13.2002C3.59998 11.8747 4.67449 10.8002 5.99998 10.8002Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M6.59998 6.50019C6.59998 3.57308 8.97287 1.2002 11.9 1.2002H12C14.9823 1.2002 17.4 3.61786 17.4 6.6002V10.8502H15.6V6.6002C15.6 4.61197 13.9882 3.0002 12 3.0002H11.9C9.96698 3.0002 8.39998 4.5672 8.39998 6.50019C8.39998 6.99725 7.99703 7.40019 7.49998 7.40019C7.00292 7.40019 6.59998 6.99725 6.59998 6.50019Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default LockOpenIcon;